import { IModule } from "app/IModule";
import SettingsModule from "./settings/settings.module";
import BidsModule from "./bids/bids.module";
import BidEditorModule from "./bidEditor/bidEditor.module";
import ReportsModule from "./reports/reports.module";
import OffersModule from "./offers/offers.module";
import TradersModule from "./settings/traders/traders.module";
import ProducersModule from "./settings/producers/producers.module";
import LocationsModule from "./locations/location.module";
import LoginModule from "./login/login.module";
import SaveIndicatorModule from "./saveIndicator/saveIndicator.module";
import CommodityModule from "./settings/commodities/commodities.module";
import OfferingsModule from "./settings/offerings/offerings.module";
import HedgingModule from "./settings/hedging/hedgings.module"
import FcmAccountsModule from "./fcmAccounts/fcmAccounts.module"
import LongShortModule from "./positions/longShort.module"
import CropYearsModule from "./cropYears/cropYears.module"
import FuturesContractsModule from "./futuresContracts/futuresContracts.module"
import PageFilterModule from "./pageFilter/pageFilter.module";
import FeatureFlagsModule from "./featureFlags/featureFlags.module";
import NotificationsModule from "./notifications/notifications.module";
import ContractsModule from "./contracts/contracts.module";
import GeoModule from "./geo/geo.module";
import DisclaimerModule from "./disclaimer/disclaimer.module";
import AlertsModule from "./alerts/alerts.module";
import SystemConfigModule from "./systemConfig/systemConfig.module";
import AccountsModule from "./accounts/accounts.module";
import UserPreferencesModule from "./userPreferences/userPreferences.module"
import MerchantsModule from "admin/features/merchants/merchants.module";
import DeliveryMethodsModule from "./deliveryMethods/deliveryMethods.module";
import DeliveryPeriodsModule from "./deliveryPeriods/deliveryPeriods.module";

const features: IModule[] = [
	new SystemConfigModule(),
	new BidsModule(),
	new BidEditorModule(),
	new SettingsModule(),
	new OffersModule(),
	new ContractsModule(),
	new ReportsModule(),
	new TradersModule(),
	new ProducersModule(),
	new LocationsModule(),
	new LoginModule(),
	new SaveIndicatorModule(),
	new CommodityModule(),
	new OfferingsModule(),
	new HedgingModule(),
	new FcmAccountsModule(),
	new LongShortModule(),
	new CropYearsModule(),
	new FuturesContractsModule(),
	new PageFilterModule(),
	new NotificationsModule(),
	new GeoModule(),
	new AlertsModule(),
	new AccountsModule(),
	new MerchantsModule(),
	new DeliveryMethodsModule(),
	new DeliveryPeriodsModule(),

	new FeatureFlagsModule(),
	new DisclaimerModule("/disclaimer"),
	new UserPreferencesModule()
];

export default features;
